<template>
    <div class="row" style="margin-top: 3px;" :id="this.oid">

        <!-- Option Properties -->
        <div class="col-md-2 quiz-left-column option-row"
             v-bind:class="{'text-success': isCorrect, 'text-danger': !isCorrect}">
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][oid]'" :value="oid"/>

            <i class="fa" v-bind:class="{'fa-check': isCorrect, 'fa-times': !isCorrect}"></i>
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][isCorrect]'" :value="isCorrect"/>
            {{isCorrect ? 'Correct' : 'Incorrect'}}<br/>
            <span style="font-weight: bold; color: #444" v-if="isSuggestedAnswer">Suggested Answer</span>
        </div>

        <!-- Option Text -->
        <div class="col-md-10 quiz-text-column option-row"
             v-bind:class="{'quiz-text-column-success': approved, 'quiz-text-column-danger': rejected}">
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][text][XX_en]'" :value="XX_en"/>

            <table>
                <tr>
                    <td>
                        <i
                                style="margin-left: 5px;"
                                class="fa fa-eye tool_tip"
                                :title="iXX_en"
                                data-toggle="tooltip">

                        </i></td>
                    <td style="padding-left: 5px;">
                        <input type="text"
                               :disabled="disabled"
                               v-model="XX_en"
                               dir="auto"
                               onfocus="preview(this.value);"
                               onkeyup="preview(this.value);"/>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            'isCorrect': Boolean,
            'iXX_en': String,
            'disabled': Boolean,
            'correctnessDisabled': Boolean,
            'idx': Number,
            'questionIdx': Number,
            'oid': String,
            'canBeDeleted': Boolean,
            'approved': Boolean,
            'rejected': Boolean,
            'isSuggestedAnswer': Boolean,
        },

        // the initial props are overwritten whenever the parent issues a re-rendering
        // (e.g. on adding/deleting questions/options), so we store them when the component
        // is loaded the first time, so we keep the user's changes.
        data: function() {
            return {
                XX_en: this.iXX_en ? this.iXX_en : '',
            };
        },
    };
</script>
